export const indications = [
 {
  name: 'name',
  title: 'NOMBRE',
  body: `Establezca un monbre a la configuracion del financiamiento, el cual debera especificar en el excel en cada producto en el que desee tal configuracion y asi en el momento de la separacion este parametrizada con dicha configuracion.`
 },
 {
  name: 'initialFee',
  title: 'CUOTA INICIAL',
  body: `Establezca un porcentage que represente el valor de la cuota inicial de cada producto en el proyecto. El pocentage que se pretenda establecer debe ser dividido entre 100 ejp: 50% = 0.5%`
 },
 {
  name: 'maxInitials',
  title: 'CUOTAS DE INICIAL',
  body: `Establezca un numero de cuotas en la que podra definir el pago de la cuota inicial en una orden. El numero de cuotas representan el numero de meses que tardara un cliente en pagar el monto prestablecido.`
 },
 {
  name: 'maxFinancing',
  title: 'CUOTAS DE FINANCIACION',
  body: `Establezca un numero de cuotas en la que podra definir el pago total de un producto, tenga en cuenta que en este numero se incluyen las cuotas que se hallan establecido en la cuota inicial. El numero de cuotas representan el numero de meses que tardara un cliente en pagar el monto prestablecido.`
 },
 {
  name: 'minFee',
  title: 'CUOTA MINIMA',
  body: `Establezca un monto minimo para cada cuota que se establezca, si el numero de la finaciacion afecta el monto minimo de las cuotas este se cambiara ala financiiacion mas cercano que cumpla con la cuota minima.`
 },
 {
  name: 'minInitialPay',
  title: 'SEPARACION',
  body: `Establezca un monto o porcentage minimo para la separacion de un producto, este corresponde al valor inicial requerido para la creacion de una orden y ara parte del valor de la cuota inicial. Si el valor establecido es menor a 1 se tomara de manera porcentual, en este caso si pretende establecer pocentage debe dividir entre 100 el porcentage deseado ejp: si desea establecer el 50% debe poner 0.5% asi sera siempre menor a 1`
 },
 {
  name: 'incentive',
  title: 'INCENTIVO',
  body: `Establezca un monto o porcentage minimo para dar como incentivo al asesor por la separacion de un producto, recuerde que este es un valor para incentivar la venta y no tiene que ver con la comision prestablecida de un asesor. Si el valor establecido es menor a 1 se tomara de manera porcentual, en este caso si pretende establecer pocentage debe dividir entre 100 el porcentage deseado ejp: si desea establecer el 50% debe poner 0.5% asi sera siempre menor a 1`
 },
 {
  name: 'lateFee',
  title: 'MORA',
  body: `Establezca un numero que sera el plazo de meses vencidos que tendra un cliente para ponerse al dia con el pago de sus cuotas atrasadas, pasado este tiempo el sistema generara un interes de mora en las cuotas vencidas. Si se deja en 0 el sistema no generara intereses por mora`
 }
];
